var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects"},_vm._l((_vm.projects),function(data){return _c('div',{key:data.id,staticClass:"list"},[_c('a',{staticClass:"link",attrs:{"href":data.link}},[_vm._v("\n        "+_vm._s(data.name)+"\n      ")]),_c('a',[_vm._v("\n         - "+_vm._s(data.description)+" \n      ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }